<template>
  <div class="batchList">
    <table class="adminUserTable">
      <thead>
        <tr>
          <th v-for="field in fields" :key="field.key">{{field.label}}</th>
        </tr>
      </thead>
      <tbody>
        <FirebaseRow v-for="direction in directionArray" :record="direction" :fields="fields" :key="direction.id" :collection="'directions'"/>
        <tr>
          <td colspan="4"><button v-on:click="addNewBatch">Add New</button></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import FirebaseRow from '../components/FirebaseRow.vue'

export default {
  name: 'creativeDirections',
  components: {
    FirebaseRow
  },
  computed: {
    directionArray () {
      return this.$store.getters.directionArray;
    },
    fields () {
      return [
        {
          "label": "Direction",
          "key": "displayName",
          "type": "String",
          "editable": false
        },
        {
          "label": "Number",
          "key": "number",
          "type": "Number",
          "editable": true
        },
        {
          "label": "Direction Name",
          "key": "name",
          "type": "String",
          "editable": true
        }
      ]
    }
  },
  methods: {
    addNewBatch () {
      this.$store.dispatch('createNewDirection')
    }
  }
}
</script>

<style>
  .groupName {
    text-align: center;
  }
  .batchList {
    width: 100%;
    height: 100%;
  }
  .adminUserTable {
    width: 100%;
    text-align: left;
    border-collapse: collapse;
  }
  td {
    border: 2px solid #2E303A;
  }
  td, th {
    padding: 15px;
  }
</style>
